import { homedir } from "node:os";

export function resolveHomeDirectory(env: NodeJS.ProcessEnv) {
  const candidate = env.HOME?.trim();
  return candidate !== undefined && candidate.length > 0 ? candidate : homedir();
}
